import { I18N_LANGUAGE_AVAILABLE, I18N_LANGUAGE_FALLBACK, I18N_NAMESPACE_FALLBACK, I18N_NAMESPACES, } from '../../constants/i18nConstants';
export const i18nConfigurationGeneral = {
    fallbackLng: I18N_LANGUAGE_FALLBACK,
    supportedLngs: I18N_LANGUAGE_AVAILABLE,
    load: 'all',
    // have a common namespace used around the full app
    // ns: ['account', 'brand', 'buy', 'checkout', 'form', 'general', 'navigation', 'product', 'social-sharing-bar', 'store'],
    ns: Object.values(I18N_NAMESPACES),
    defaultNS: I18N_NAMESPACE_FALLBACK,
    debug: false,
    compatibilityJSON: 'v1',
    keySeparator: '***',
    interpolation: {
        prefix: '{',
        suffix: '}',
        escapeValue: false, // not needed for react!!
    },
    react: {
        bindI18n: 'languageChanged loaded',
        nsMode: 'default',
        useSuspense: false,
    },
    backend: {
        // Translations are owned by product-lister-react (@as-react/translations), not
        // fetched from AEM: SSR supplies resources up-front and the client sets its own
        // loadPath (see apps/hono i18n-client). Only queryStringParams is consumed here.
        // adds parameters to resource URL. 'example.com' -> 'example.com?v=1.3.5'
        queryStringParams: {},
    },
    cache: {
        // turn on or off
        enabled: false,
        // prefix for stored languages
        prefix: 'i18next_res_',
        // expiration
        expirationTime: 7 * 24 * 60 * 60 * 1000,
        // language versions
        versions: {},
    },
};
